import { RSAA } from 'redux-api-middleware'

import { types, initialState } from './index'
import { contentfulEndpoint, getContentfulProxyHeaders } from './utils'
/**
 * Help center fetch contentful data that requires a graphql query
 *
 * @param {String} query The graphql query, should be passed in to the endpoint
 *   from the the component thats calling this action
 */
export const fetchHelpArticlesByCategoryData = query => {
  return {
    [RSAA]: {
      endpoint: contentfulEndpoint,
      method: 'POST',
      headers: getContentfulProxyHeaders(),
      body: JSON.stringify({ query }),
      types: [
        types.FETCH_HELP_ARTICLES_BY_CATEGORY_DATA_REQUEST,
        types.FETCH_HELP_ARTICLES_BY_CATEGORY_DATA_SUCCESS,
        types.FETCH_HELP_ARTICLES_BY_CATEGORY_DATA_ERROR,
      ],
      cache: true,
    },
  }
}

export const clearHelpArticlesByCategoryData = () => ({
  type: types.CLEAR_HELP_ARTICLES_BY_CATEGORY_DATA,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    // -- Help articles by category Contentful store
    case types.FETCH_HELP_ARTICLES_BY_CATEGORY_DATA_REQUEST: {
      return {
        ...state,
        articlesByCategory: {
          ...state.articlesByCategory,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_HELP_ARTICLES_BY_CATEGORY_DATA_SUCCESS: {
      const { data } = payload
      // Break out the contentful payload data into separate stores
      const articlesByCategory = data.articlesByCategory
      const singleCategory = data.singleCategory

      // We reached the last page if the total is smaller than a single page
      // or the total is smaller than the current skip amount
      const isLastPageReached =
        articlesByCategory?.total <= 20 ||
        articlesByCategory?.total <= articlesByCategory?.skip

      // Append the new articles to the existing ones for pagination
      let mergedEntities = []
      if (state.articlesByCategory.entities?.articles) {
        mergedEntities = state.articlesByCategory.entities?.articles?.concat(
          articlesByCategory?.articles,
        )
      } else {
        mergedEntities = articlesByCategory?.articles
      }

      return {
        ...state,
        articlesByCategory: {
          ...state.articlesByCategory,
          busy: false,
          entities: {
            ...state.articlesByCategory.entities,
            articles: mergedEntities,
            skip: articlesByCategory?.skip,
            total: articlesByCategory?.total,
          },
          isLastPageReached,
        },
        singleCategory: {
          ...state.singleCategory,
          entities: singleCategory,
          busy: false,
        },
      }
    }

    case types.FETCH_HELP_ARTICLES_BY_CATEGORY_DATA_ERROR: {
      return {
        ...state,
        articlesByCategory: {
          ...state.articlesByCategory,
          busy: false,
          error: payload,
        },
      }
    }

    // Safe to set busy: true here — only the Category component reads this slice.
    case types.CLEAR_HELP_ARTICLES_BY_CATEGORY_DATA: {
      return {
        ...state,
        articlesByCategory: {
          ...state.articlesByCategory,
          busy: true,
          entities: initialState.articlesByCategory.entities,
        },
      }
    }

    default:
      return state
  }
}
